import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background: #b0b7e7;
  border-radius: 25px;
  padding: 2rem;
  margin: 1rem;
  position: relative;

  .phoneNumber {
  }

  .half {
    flex-basis: 50%;
  }

  form {
    margin: auto;
    max-width: 40rem;
  }

  a {
    color: #097273;
  }

  @media (min-width: ${screen('lg')}) {
    background: url('/images/home-v2/home-v2-form-bg.svg') no-repeat top center;
    background-size: contain;
    margin: 0 0 2rem 0;
    border-radius: 0;
    padding: 4rem 0;
  }
`;

const Intro = styled.div`
  h2 {
    margin-top: 0;
    font-size: ${fontSize('xl2')};
    text-wrap: balance;
    margin-bottom: 2rem;
  }

  @media (min-width: ${screen('lg')}) {
    text-align: center;

    h2 {
      font-size: ${fontSize('xl4')};
      margin-bottom: 3rem;
    }
  }
`;

export const Form = {
  Root,
  Intro
};
